var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_vm._v(" id=\"app\"> "),_c('v-app-bar',{attrs:{"app":""}},[_c('NavBar')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }